import { useMemo } from 'react';

//* HOC's
import { withUIContext, withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import Text from 'components/common/Text';
import Info from 'components/common/Info';
import Paths from 'components/common/Paths';
import Content from 'components/common/Content';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import BackButton from 'components/common/BackButton';
import LinearSlider from 'components/common/LinearSlider';
import EventItem from 'components/pages/events/EventItem';

//* Style
import EventIndividualStyle from 'styles/pages/EventIndividualStyle';

const EventIndividual = ({ singleEvent, prevRoute, pageParams, selectedLang, winWidth, screenSizes }) => {
	//! Single Event data
	const singleEventData = useMemo(() => singleEvent?.[pageParams.selectedSlug]?.[selectedLang], [singleEvent, pageParams, selectedLang]);

	//! Store similar events
	const storeSimilarEvents = useMemo(() => {
		let mutatedEventsArr = [];

		if (winWidth >= 1024 && winWidth < 1280) {
			mutatedEventsArr = singleEventData?.similarEvents.slice(0, 3);
		} else if (winWidth < 1024 && winWidth >= 768) {
			mutatedEventsArr = singleEventData?.similarEvents.slice(0, 2);
		} else {
			mutatedEventsArr = singleEventData?.similarEvents;
		}

		return mutatedEventsArr?.map((event, index) => {
			return (
				<EventItem
					index={index}
					data={event}
					className='similar-events col-3 col-dl-3 col-dm-3 col-ds-3 col-dxs-3 col-t-4 col-ts-6 col-m-12'
					key={index}
				/>
			);
		});
	}, [singleEventData, winWidth, screenSizes]);

	//! Store related events
	const storeRelatedEvents = useMemo(() => {
		let mutatedEventsArr = [];

		if (winWidth >= 1024 && winWidth < 1280) {
			mutatedEventsArr = singleEventData?.relatedEvents.slice(0, 3);
		} else if (winWidth < 1024 && winWidth >= 768) {
			mutatedEventsArr = singleEventData?.relatedEvents.slice(0, 2);
		} else {
			mutatedEventsArr = singleEventData?.relatedEvents;
		}

		return mutatedEventsArr?.map((event, index) => {
			return (
				<EventItem
					index={index}
					data={event}
					className='similar-events col-3 col-dl-3 col-dm-3 col-ds-3 col-dxs-3 col-t-4 col-ts-6 col-m-12'
					key={index}
				/>
			);
		});
	}, [singleEventData, winWidth, screenSizes]);

	return (
		<Page
			meta={singleEventData?.event?.meta}
			transparentHeader={pageParams.transparentHeader && !singleEventData}
			nextSeoProps={{
				noindex: selectedLang != 'en',
			}}
			hrefLang={false}
		>
			{singleEventData && (
				<EventIndividualStyle>
					<div className='page-top'>
						<Paths
							paths={['Events', singleEventData.event.title]}
							pathColor={'primaryColor1'}
						/>
						<BackButton
							isEvent={true}
							prevRoute={prevRoute}
							backRoute={'/'}
							text={'backToEvents'}
						/>
					</div>

					<Container
						section
						className='main-content-wrap'
					>
						<Info
							isSticky={true}
							data={singleEventData.event}
						/>
						<Content
							image={singleEventData.event.banner_image}
							text={singleEventData.event.description}
						/>
					</Container>

					{singleEventData && (
						<Container section>
							<Feedback
								type={singleEventData.event.feedbackType}
								typeId={singleEventData.event.id}
							/>
						</Container>
					)}

					{singleEventData.event.gallery_images.length !== 0 && (
						<Container
							full
							section
							className='bgBlackPearl slider-wrap'
						>
							<LinearSlider items={singleEventData.event.gallery_images} />
						</Container>
					)}

					{singleEventData?.similarEvents.length !== 0 && (
						<Container section>
							<Text
								className={'h3 font-ping-bolder'}
								text={'similarEvents'}
							/>
							<Container
								full
								row
								className='items-wrap'
							>
								{storeSimilarEvents}
							</Container>
						</Container>
					)}

					{singleEventData?.relatedEvents.length !== 0 && (
						<Container section>
							<Text
								className={'h3 font-ping-bolder'}
								text={'youMightAlsoBeInterestedIn'}
							/>
							<Container
								full
								row
								className='items-wrap'
							>
								{storeRelatedEvents}
							</Container>
						</Container>
					)}
				</EventIndividualStyle>
			)}
		</Page>
	);
};

export default withUIContext(withDataContext(EventIndividual, ['singleEvent', 'prevRoute']), ['winWidth', 'screenSizes']);
